import { useCallback } from 'react';
import { useAuth } from './auths/useAuthService';
import { useMessageStore } from '../stores/useMessageStore';
import { useFilterOptions } from '../stores/useFilterOptions';
import { useFiltersStore } from '../stores/useFilters';

export const useSignOut = (onComplete?: () => void) => {
  const { logout } = useAuth();
  const resetMessages = useMessageStore((state) => state.reset);
  const resetFiltersOptions = useFilterOptions((state) => state.reset);
  const resetFilters = useFiltersStore((state) => state.resetData);

  return useCallback(() => {
    logout().then(() => {
      resetMessages();
      resetFiltersOptions();
      resetFilters();
      onComplete?.();
    });
  }, [logout, resetMessages, resetFiltersOptions, resetFilters, onComplete]);
}; 